module.exports = __webpack_public_path__ + "81f3900476c5ee9f8524f0d25b1d8811.svg";